<div *ngIf="data" class="request-revision-modal__wrapper">
  <!-- Custom header for redesign/remanufacture -->
  <div *ngIf="data.headerMessage" class="request-revision-modal__header">
    <p class="request-revision-modal__header-message">{{ data.headerMessage }}</p>

    <div class="request-revision-modal__info-section">
      <div *ngIf="data.patientName" class="request-revision-modal__info-item">
        <strong>{{ 'general.patientName' | translate }}:</strong>
        &nbsp;{{ data.patientName }}
      </div>
      <div *ngIf="data.treatmentType" class="request-revision-modal__info-item">
        <strong>{{ 'general.treatmentType' | translate }}:</strong>
        &nbsp;{{ data.treatmentType }}
      </div>
    </div>
  </div>

  <div>
    <p-ifta-label>
      <p-select
        optionLabel="name"
        optionValue="id"
        styleClass="w-full"
        inputId="revisionReasonId"
        [options]="reasons"
        [formControl]="form.controls.reasonId"
      />
      <!--suppress XmlInvalidId -->
      <label for="revisionReasonId">{{ 'general.selectRequestRevisionReason' | translate }}&nbsp;*</label>
    </p-ifta-label>
  </div>

  <div>
    <p-ifta-label>
      <textarea
        id="revisionComment"
        pTextarea
        style="resize: none"
        rows="10"
        [formControl]="form.controls.comment"
      ></textarea>
      <label for="revisionComment">
        {{ 'general.addAdditionalExplanation' | translate }}
        <ng-container *ngIf="(selectedReason$ | async)?.isRequiredComment">&nbsp;*</ng-container>
      </label>
    </p-ifta-label>
  </div>
</div>

<div class="request-revision-modal__footer">
  <p-button
    severity="secondary"
    [outlined]="true"
    [disabled]="data?.isLoading$ | async"
    [label]="'general.cancel' | translate"
    (onClick)="onCancel()"
  />

  <p-button
    severity="primary"
    [disabled]="(data?.isLoading$ | async) || form.invalid"
    [loading]="data?.isLoading$ | async"
    [outlined]="true"
    [label]="'general.request' | translate"
    (onClick)="onRequest()"
  />
</div>
